import React, { Fragment, useEffect, useRef, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import enhancer from "./validator";
import AdminServices from "../../api/AdminServices";
import Toaster from "../common/Toaster";
import { withRouter } from "react-router-dom";
import AuthActions from "../../redux/auth/actions";
import { ImageResolution } from "../../helper/constant";
import EncryptDecrypt from "../../api/EncryptDecrypt";
import PracticeMangementServices from "api/PracticeManagementServices";
import { Input } from "reactstrap";

const { admin } = AuthActions;

const EditProfileForm = props => {
  const {
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    onSubmit,
    setFieldValue,
    setFieldTouched,
    values,
    action
  } = props;

  const toaster = useRef(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [imageObj, setImageObj] = useState(null);
  const [loading, setLoading] = useState(false);
  const [practiceList, setPracticeList] = useState([]);

  useEffect(() => {
    if (
      !practiceList?.length ||
      (!practiceList?.length && props?.admin_role_id == 6)
    ) {
      PracticeMangementServices.list({ get_all: true }).then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data?.status) {
          setPracticeList([...data?.data]);
        }
      });
    }
  }, [props?.admin_role_id]);
  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span></span>;
    }
  };
  const handleImage = (e, setValue) => {
    if (e.target.files[0]) {
      let fileObj = e.target.files[0];

      if (fileObj.size > 10 * 1024 * 1024) {
        if (toaster.current)
          toaster.current.error("Please upload a file smaller than 10 MB");
        return false;
      }

      if (!fileObj.name.match(/\.(jpg|jpeg|png|gif|heif)$/)) {
        if (toaster.current)
          toaster.current.error(
            "Only .jpg, .jpeg, .gif, .png, .heif are allowed"
          );
        return false;
      }

      if (fileObj) {
        const img = new Image();

        img.src = window.URL.createObjectURL(fileObj);

        img.onload = function() {
          const width = img.naturalWidth,
            height = img.naturalHeight;

          window.URL.revokeObjectURL(img.src);
          setValue("width", width);
          setValue("height", height);
          setFieldTouched("image", true, true);
          if (
            width >= ImageResolution.WIDTH &&
            height >= ImageResolution.HEIGHT
          ) {
            setImageObj(fileObj);
            setValue("image", URL.createObjectURL(fileObj));
            setUploadImage(URL.createObjectURL(fileObj));
          }
        };
      } else {
        //No file was input or browser doesn't support client side reading
        // form.submit();
      }
    } else {
      setUploadImage(null);
    }
  };
  const handleSubmit = () => {
    let { values, isValid, handleSubmit } = props;
    if (isValid) {
      onSubmit(values, action);
      const params = {
        first_name: values.first_name,
        last_name: values.last_name
      };

      let data1 = EncryptDecrypt.encrypt(params);
      const formdata = new FormData();
      formdata.append("data", data1?.data);
      if (imageObj) formdata.append("data1", imageObj);
      setLoading(true);

      AdminServices.update(formdata)
        .then(res => {
          let data = EncryptDecrypt.decrypt(res.data);
          if (data.status) {
            if (toaster.current) toaster.current.success(data.message);
            props.admin({
              first_name: data.data.first_name,
              last_name: data.data.last_name,
              profile_image: data.data.profile_image
            });
            AdminServices.registerInGetStream()
              .then(res => {
                let data = EncryptDecrypt.decrypt(res.data);
                if (data.status) {
                  console.log("Updated info in getstream.io");
                } else {
                  console.log("Error while updating in getstream.io");
                }
              })
              .catch(err => {
                console.log("Error while updating in getstream.io");
              });
            setTimeout(() => {
              setLoading(false);
              props.history.push("/dashboard");
            }, 1000);
          } else {
            if (toaster.current) toaster.current.error(data.message);
          }
        })
        .catch(err => {
          console.log("handleSubmit -> err", err);
          if (toaster.current) toaster.current.error(err.response);
        });
    }
    handleSubmit();
  };

  return (
    <div>
      <form>
        <div className="form-group">
          <label className="fs-16 medium-text">First name</label>
          <input
            type="text"
            className="form-control react-form-input"
            id="first_name"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.first_name}
            placeholder="First name"
          />
          <Error field="first_name" />
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">Last name</label>
          <input
            type="text"
            className="form-control react-form-input"
            id="last_name"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.last_name}
            placeholder="Last name"
          />
          <Error field="last_name" />
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">Email</label>
          <input
            type="email"
            className="form-control react-form-input"
            id="email"
            disabled
            onChange={handleChange}
            onBlur={handleBlur}
            value={props.email}
            placeholder="Email"
          />
          <Error field="email" />
        </div>
        {props?.admin_role_id == 6 && (
          <div className="form-group">
            <label className="fs-16 medium-text">
              Practice<span className="asterisk">*</span>
            </label>
            <Input
              type="select"
              name=""
              id="practice"
              onChange={handleChange}
              value={values.practice}
              onBlur={handleBlur}
              disabled
            >
              <option value="">Select Practice</option>
              {practiceList.map((type, i) => {
                return (
                  <Fragment>
                    <option key={`option${i}`} value={type.id}>
                      {type.practice_name}
                    </option>
                  </Fragment>
                );
              })}
            </Input>
            <Error field="practice" />
          </div>
        )}
        <div>
          <div className="form-group">
            <label className="fs-16 medium-text">
              Profile<span className="asterisk">*</span>
            </label>
            <br />
            <div className="file-upload">
              <label className="c-btn c-primary form-button fs-16 demi-bold-text mt-15">
                Upload image
                <input
                  id="profile_photo"
                  className="file-upload__input"
                  name="file-upload"
                  type="file"
                  accept="image/jpg,image/png,image/jpeg"
                  onChange={e => handleImage(e, setFieldValue)}
                  onBlur={handleBlur}
                  onClick={event => {
                    event.target.value = "";
                  }}
                />
              </label>
            </div>
            <br />
            {
              <img
                src={uploadImage ? uploadImage : values.profile_image}
                alt=""
                className="mtb-15"
                style={{
                  width: "200px",
                  borderRadius: "4%",
                  height: "150px",
                  background: "#404040"
                }}
              />
            }
            <br />
            <Error field="profile_photo" />
          </div>
        </div>
        <div>
          <button
            loading={loading}
            disabled={loading}
            type="button"
            className="c-btn c-info form-button fs-16 demi-bold-text"
            style={{ maxWidth: "125px", position: "relative" }}
            onClick={() => handleSubmit()}
            dataStyle="expand-right"
          >
            Submit
          </button>
        </div>
      </form>
      <Toaster ref={toaster} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    first_name: state.auth.first_name,
    last_name: state.auth.last_name,
    email: state.auth.email,
    profile_image: state.auth.profile_image,
    practice: state.auth.practice,
    admin_role_id: state.auth.admin_role_id,
    ...state.themeChanger
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, { admin }),
  enhancer
)(EditProfileForm);
